<main class="grow" role="content">
  <div class="kt-container-fixed invoices-wide-container py-5 lg:py-7.5">
    <div class="kt-card">
      <div class="kt-card-header min-h-16 flex-wrap gap-3">
        <h1 class="kt-card-title">Invoices</h1>
        <div class="inline-flex items-center gap-2.5 flex-wrap">
          <input
            #invoiceSearch
            type="text"
            class="kt-input sm:w-80"
            placeholder="Search invoices..."
            [value]="searchTerm()"
            (input)="onSearchChange(invoiceSearch.value)"
            aria-label="Search invoices"
          />
          <a class="kt-btn kt-btn-outline" [routerLink]="['/invoices/create']">
            <i class="ki-filled ki-plus text-sm" aria-hidden="true"></i>
            <span>New Invoice</span>
          </a>
        </div>
      </div>

      <div class="filter-toolbar px-5 py-4 border-b border-input">
        <div class="filter-grid">
          <label class="field-block">
            <span class="field-label">Vendor</span>
            <select class="kt-select" [ngModel]="selectedVendorFilter()" (ngModelChange)="onVendorFilterChange($event)">
              <option value="all">All vendors</option>
              @for (vendor of vendorFilterOptions(); track vendor.id) {
                <option [value]="vendor.id">{{ vendor.name }}</option>
              }
            </select>
          </label>

          <label class="field-block">
            <span class="field-label">Linked To</span>
            <select class="kt-select" [ngModel]="selectedLinkTypeFilter()" (ngModelChange)="onLinkTypeFilterChange($event)">
              <option value="all">All link types</option>
              @for (option of linkTypeOptions(); track option.code) {
                <option [value]="option.uiType">{{ option.name }}</option>
              }
            </select>
          </label>

          <label class="field-block">
            <span class="field-label">Invoice Concept</span>
            <select class="kt-select" [ngModel]="selectedConceptFilter()" (ngModelChange)="onConceptFilterChange($event)">
              <option value="all">All concepts</option>
              @for (option of invoiceTypeOptions(); track option.id) {
                <option [value]="option.name">{{ option.name }}</option>
              }
            </select>
          </label>
        </div>

        <button type="button" class="kt-btn kt-btn-sm kt-btn-outline self-end" (click)="clearFilters()">
          Clear filters
        </button>
      </div>

      <div class="kt-card-content p-0">
        @if (isLoading()) {
          <div class="catalog-loading" role="status" aria-live="polite" aria-label="Loading invoices">
            <span class="catalog-loading-spinner" aria-hidden="true"></span>
            <span class="catalog-loading-text">Loading...</span>
          </div>
        }

        @if (loadError()) {
          <div class="kt-alert kt-alert-destructive m-5">{{ loadError() }}</div>
        }

        @if (!isLoading()) {
          <div class="kt-card-table invoices-compact-table">
            <div class="kt-table-wrapper kt-scrollable">
              <table class="kt-table">
              <thead>
                <tr>
                  <th scope="col">Added At</th>
                  <th scope="col">Invoice #</th>
                  <th scope="col">Vendor</th>
                  <th scope="col">Vendor Type</th>
                  <th scope="col">Concepts</th>
                  <th scope="col">Linked To</th>
                  <th scope="col">Issue Date</th>
                  <th scope="col">Invoice Total</th>
                  <th scope="col">User</th>
                  <th scope="col" class="text-end">Actions</th>
                </tr>
              </thead>
                <tbody>
                @for (invoice of pagedInvoices(); track trackByInvoice($index, invoice)) {
                  <tr>
                    <td>{{ formatDate(invoice.createdAt) }}</td>
                    <td>
                      <a class="text-primary hover:underline" [routerLink]="['/invoices', invoice.id]">
                        {{ invoice.invoiceNumber }}
                      </a>
                    </td>
                    <td>{{ invoice.vendorName }}</td>
                    <td>{{ vendorTypeFor(invoice) }}</td>
                    <td>{{ invoice.invoiceConceptNames.join(', ') || '-' }}</td>
                    <td>{{ linkedToLabel(invoice) }}</td>
                    <td>{{ formatDate(invoice.issueDate) }}</td>
                    <td class="text-end">{{ formatAmount(invoice.currency, invoice.amount) }}</td>
                    <td>{{ invoice.lastModifiedBy || invoice.createdBy || '-' }}</td>
                    <td class="text-end">
                      <div class="inline-flex items-center gap-2">
                        <a class="kt-btn kt-btn-sm kt-btn-outline" [routerLink]="['/invoices', invoice.id]">
                          Edit
                        </a>
                        <button type="button" class="kt-btn kt-btn-sm kt-btn-destructive" (click)="deleteInvoice(invoice)">
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="10" class="text-center text-secondary-foreground py-6">No invoices found.</td>
                  </tr>
                }
                </tbody>
              </table>
            </div>

            <div class="flex items-center justify-between gap-3 flex-wrap px-5 py-4">
              <span class="text-sm text-secondary-foreground">{{ rangeLabel() }}</span>
              <div class="inline-flex items-center gap-2">
                <button
                  type="button"
                  class="kt-btn kt-btn-sm kt-btn-outline"
                  [disabled]="pageNumber() <= 1"
                  (click)="goToPreviousPage()"
                >
                  Previous
                </button>
                <span class="text-sm text-secondary-foreground">Page {{ pageNumber() }} / {{ totalPages() }}</span>
                <button
                  type="button"
                  class="kt-btn kt-btn-sm kt-btn-outline"
                  [disabled]="pageNumber() >= totalPages()"
                  (click)="goToNextPage()"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</main>
